:host([fillSpace]) {
  .gz-tab-group {
    .gz-tab-group-header {
      button {
        flex: auto;
        min-width: 0;
        text-align: left;

        .header-text {
          display: inline;
        }
      }
    }
  }
}

:host([noWrap]) {
  .gz-tab-group {
    .gz-tab-group-header {
      button {
        flex: 1;
      }
    }
  }
}

.gz-tab-group {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .gz-tab-group-header {
    width: 100%;
    height: auto;

    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: center;

    border-bottom: 2px solid var(--chart-101-pressed-dividers);
    padding: 0 var(--tab-header-padding-right, 1px) 0 var(--tab-header-padding-left, 0);

    button {
      font-size: var(--body-size-large);
      height: 46px;
      margin: 1px 0;
      padding: 0 var(--spacer);
      text-transform: uppercase;
      cursor: pointer;
      position: relative;
      border-radius: 0;
      border: 0;
      outline: 0;
      background-color: transparent;
      color: var(--main-titles-inputs-600);
      transition: background-color 100ms;

      &:focus-visible {
        background-color: transparent;
        outline: var(--blue-layout-500-focus) 1px solid;
        background: var(--focus-bg-color);
      }

      &:hover {
        background-color: var(--chart-050-hover);
      }

      &:active {
        background-color: var(--chart-102-pressed);
      }

      &.selected {
        background-color: transparent;
        color: var(--main-titles-inputs-600);

        &:after {
          content: '';
          background-color: var(--blue-layout-400-primary);
          position: absolute;
          width: 100%;
          height: 2px;
          bottom: -2px;
          left: 0;
        }
      }

      &[disabled] {
        pointer-events: none;
        transition: none;
        cursor: default;
        color: var(--grey-layout-200-disabled);
      }

      &:not(:last-child) {
        padding-right: calc(var(--spacer) * 2);
      }
    }
  }

  .tab-slot-wrapper {
    flex: auto;
    position: relative;
  }
}

gz-tooltip {
  width: 100%;
}
